import { useFormik } from 'formik';
import { Link } from 'react-router-dom';
import { handleRedacao, listRedacoes } from '../../../api/redacao';
import { handleMyPlans, handleOnlyPlans } from '../../../api/pagamento';
import ErrorMsg, { ErrorApiMsg, SuccessApiMsg } from './error-msg';
import { redacaoSchema } from './validation-schema';
import React, { useState, useEffect } from 'react';
import { retrieveToken } from '../../../hooks/use-token';
import { useNavigate } from "react-router-dom";

const RedacaoForm = ({ htmlContent }) => {

  const [apiErrors, setApiErrors] = useState(null);
  const [apiSuccess, setApiSuccess] = useState(null);
  const [planos, setPlanos] = useState(null);
  const navigate = useNavigate();
  const [isSubmting, setIsSubmiting] = useState(false);
  const [file, setFile] = useState(null);

  useEffect(() => {
    
    if (planos == null) {
      
      const tokenApi = retrieveToken();

      handleOnlyPlans(tokenApi).then(function(result) {
        if (result.length > 0) {
          setPlanos(result);
        } else {
          setPlanos(null);
        }
      });

    }

  });

  const handleOnSubmit = (values, { resetForm }) => {

    if (isSubmting == false) {

      setApiErrors(null);
      setApiSuccess(null);

      setIsSubmiting(true);

      const tokenApi = retrieveToken();

      var filereader = new FileReader();
      filereader.readAsDataURL(file);
      
      filereader.onload = function (evt) {
      
        var base64 = evt.target.result;
      
        handleRedacao(tokenApi, {
          "plano_fk": values.plano, 
          "tema": values.tema,
          "file": base64
        }).then(res => {
    
          setIsSubmiting(false); 
    
          if (res.status) {
    
            setApiSuccess('Sucesso! Sua redação foi enviada, aguarde a correção.');
            setFieldValue("file", "");
            setFile(null);
            resetForm();
            setTimeout(() => {
              window.location.reload();
            }, 2000)
    
          } else {
    
            setApiErrors(res.message);
    
          }
          
        });

     }
      
    
    } 

  }

  function HtmlRenderer({ htmlContent }) {
    return (
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    );
  }

  // use formik
  const { handleChange, handleSubmit, handleBlur, errors, values, touched, setFieldValue } = useFormik({
    initialValues: { plano: '', tema: '', file: '' },
    validationSchema: redacaoSchema,
    onSubmit: handleOnSubmit
  });

  return (planos != null) ? (
    <div>
      <div style={{marginTop: "15px"}}>
                <HtmlRenderer htmlContent={htmlContent} />
                </div>
    <form onSubmit={handleSubmit} style={{marginTop: "40px"}}>
       
       <div className="col-md-12">
        <h5>Selecione o Plano para o qual você deseja enviar a redação:</h5>
        <div className="country-select">

        <select className="form-select" name="plano" onChange={handleChange} onBlur={handleBlur} value={values.plano}>
          <option>Selecione</option>
          {Array.isArray(planos) && planos.length > 0 && planos != null && planos.map(option => (
            <option key={option.cd_plano} value={option.cd_plano}>
              {option.titulo}
            </option>
          ))}
          </select>
          {touched.plano && <ErrorMsg error={errors.plano} />}
        </div>
        
      </div>
      <div className="col-md-12">
        <h5>Tema: </h5>
        <div className="checkout-form-list">
          <input value={values.tema} onChange={handleChange}
            onBlur={handleBlur} maxLength="150" name="tema" type="text" placeholder="Digite o tema da sua redação" />
            {touched.tema && <ErrorMsg error={errors.tema} />}
        </div>
      </div>
      <div className="col-md-12">
        <h5>Arquivo PDF</h5>
        <div className="checkout-form-list">
          <input onChange={({ currentTarget }) => {
            const file = currentTarget.files[0];
            if (file) {
              setFieldValue("file", file);
              setFile(file);
            }
          }}
            onBlur={handleBlur} name="file" type="file" accept="application/pdf" placeholder="Arquivo PDF" />
            {touched.file && <ErrorMsg error={errors.file} />}
        </div>
      </div>
     
      <button className="e-btn"> { (isSubmting) ? <span><i className="fal fa-spinner"></i></span> : 'Enviar minha redação' }</button>

      {apiErrors && <ErrorApiMsg error={apiErrors} />}

      {apiSuccess && <SuccessApiMsg msg={apiSuccess} />}
      
    </form>
    </div>
    ) : (<div className="col-md-12">
      <h4 className='mt-5'>Não identificamos planos ativos para envio de redações.</h4>
      <button className="e-btn mt-5" onClick={() => navigate("/cursos")}>Conhecer os cursos</button>
      </div>);
};

export default RedacaoForm;